import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import ReactGA from 'react-ga4';
import AppWrapper from './AppWrapper';
import { AppProvider } from './context/appContext';
import ScrollToTop from './utils/ScrollToTop';
import { initFacebookSdk } from './utils/InitFacebookSdk';
import wallistThemeCssUrl from './assets/theme/blue/w-theme.css';
import baseThemeCssUrl from './assets/theme/p-theme-bootstrap.css';
import layoutCssUrl from './assets/theme/layout-light.css';

const root = ReactDOM.createRoot(document.getElementById('root'));


if (process.env.NODE_ENV === 'production') {
    ReactGA.initialize('G-WBM67LKS5V');
}
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false
        }
    }
});

const facebookEnabled = false;
if (facebookEnabled) {
    initFacebookSdk().then(startApp);
} else {
    startApp();
}
function startApp() {
    const layoutLinkEl = document.getElementById('layout-css');
    if (layoutLinkEl && layoutCssUrl) {
        layoutLinkEl.href = layoutCssUrl;
    }
    const baseThemeLinkEl = document.getElementById('theme-css-base');
    if (baseThemeLinkEl && baseThemeCssUrl) {
        baseThemeLinkEl.href = baseThemeCssUrl;
    }
    const themeLinkEl = document.getElementById('wallist-theme-css');
    if (themeLinkEl && wallistThemeCssUrl) {
        themeLinkEl.href = wallistThemeCssUrl;
    }
    
    root.render(
        <QueryClientProvider client={queryClient}>
            {/* <GoogleOAuthProvider clientId="684840638475-tk7b756fekgn9h3f4v45k98ik9crogin.apps.googleusercontent.com"> */}
            <AppProvider>
                <BrowserRouter>
                    <ScrollToTop />
                    <AppWrapper />
                </BrowserRouter>
            </AppProvider>
            {/* </GoogleOAuthProvider> */}
        </QueryClientProvider>
    );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
